class NoteTypePresenter {
  constructor(noteTypeData) {
    this.slug = noteTypeData?.slug;
    this.markdownPreview = noteTypeData?.markdown_preview ?? noteTypeData?.markdownPreview;
  }

  getSlug() {
    return this.slug;
  }

  getMarkdownPreview() {
    return this.markdownPreview;
  }
}

export default NoteTypePresenter;


